module.exports = __webpack_public_path__ + "img/fb.468858d9.svg";